/**
 * client/element-skins.ts
 * Responsabilidad: Catálogo en memoria, precarga y gestión de texturas PixiJS
 * e imágenes HTMLImageElement para las Skins Elementales del jugador.
 */

import { Texture } from "pixi.js";

export interface ElementSkinDef {
    id: string;
    element: string;
    tier: number;
    name: string;
    assetPath: string;
    priceCrystals: number;
    priceOrbs: number;
    isUnlockedByDefault: number;
    sortOrder: number;
    isActive: number;
}

export const FALLBACK_ELEMENT_SKINS: readonly ElementSkinDef[] = [
    // Agua (agua_001 a agua_005)
    { id: "agua_001", element: "water", tier: 1, name: "Aquaspirit Primordial", assetPath: "assets/SkinsElementales/agua_001.png", priceCrystals: 0, priceOrbs: 0, isUnlockedByDefault: 1, sortOrder: 1, isActive: 1 },
    { id: "agua_002", element: "water", tier: 2, name: "Aquaspirit Torrencial", assetPath: "assets/SkinsElementales/agua_002.png", priceCrystals: 1500, priceOrbs: 15, isUnlockedByDefault: 0, sortOrder: 2, isActive: 1 },
    { id: "agua_003", element: "water", tier: 3, name: "Aquaspirit Glacial", assetPath: "assets/SkinsElementales/agua_003.png", priceCrystals: 4000, priceOrbs: 40, isUnlockedByDefault: 0, sortOrder: 3, isActive: 1 },
    { id: "agua_004", element: "water", tier: 4, name: "Aquaspirit Abisal", assetPath: "assets/SkinsElementales/agua_004.png", priceCrystals: 7500, priceOrbs: 70, isUnlockedByDefault: 0, sortOrder: 4, isActive: 1 },
    { id: "agua_005", element: "water", tier: 5, name: "Aquaspirit Maelstrom", assetPath: "assets/SkinsElementales/agua_005.png", priceCrystals: 12000, priceOrbs: 120, isUnlockedByDefault: 0, sortOrder: 5, isActive: 1 },
    // Eléctrico (electrico_001 a electrico_005)
    { id: "electrico_001", element: "electric", tier: 1, name: "Electraspirit Primordial", assetPath: "assets/SkinsElementales/electrico_001.png", priceCrystals: 0, priceOrbs: 0, isUnlockedByDefault: 1, sortOrder: 6, isActive: 1 },
    { id: "electrico_002", element: "electric", tier: 2, name: "Electraspirit Chispa", assetPath: "assets/SkinsElementales/electrico_002.png", priceCrystals: 1500, priceOrbs: 15, isUnlockedByDefault: 0, sortOrder: 7, isActive: 1 },
    { id: "electrico_003", element: "electric", tier: 3, name: "Electraspirit Plasma", assetPath: "assets/SkinsElementales/electrico_003.png", priceCrystals: 4000, priceOrbs: 40, isUnlockedByDefault: 0, sortOrder: 8, isActive: 1 },
    { id: "electrico_004", element: "electric", tier: 4, name: "Electraspirit Rayo", assetPath: "assets/SkinsElementales/electrico_004.png", priceCrystals: 7500, priceOrbs: 70, isUnlockedByDefault: 0, sortOrder: 9, isActive: 1 },
    { id: "electrico_005", element: "electric", tier: 5, name: "Electraspirit Tempestad", assetPath: "assets/SkinsElementales/electrico_005.png", priceCrystals: 12000, priceOrbs: 120, isUnlockedByDefault: 0, sortOrder: 10, isActive: 1 },
    // Fuego (fuego_001 a fuego_005)
    { id: "fuego_001", element: "fire", tier: 1, name: "Ignis Primordial", assetPath: "assets/SkinsElementales/fuego_001.png", priceCrystals: 0, priceOrbs: 0, isUnlockedByDefault: 1, sortOrder: 11, isActive: 1 },
    { id: "fuego_002", element: "fire", tier: 2, name: "Ignis Calcinante", assetPath: "assets/SkinsElementales/fuego_002.png", priceCrystals: 1500, priceOrbs: 15, isUnlockedByDefault: 0, sortOrder: 12, isActive: 1 },
    { id: "fuego_003", element: "fire", tier: 3, name: "Ignis Magmático", assetPath: "assets/SkinsElementales/fuego_003.png", priceCrystals: 4000, priceOrbs: 40, isUnlockedByDefault: 0, sortOrder: 13, isActive: 1 },
    { id: "fuego_004", element: "fire", tier: 4, name: "Ignis Volcánico", assetPath: "assets/SkinsElementales/fuego_004.png", priceCrystals: 7500, priceOrbs: 70, isUnlockedByDefault: 0, sortOrder: 14, isActive: 1 },
    { id: "fuego_005", element: "fire", tier: 5, name: "Ignis Hipernova", assetPath: "assets/SkinsElementales/fuego_005.png", priceCrystals: 12000, priceOrbs: 120, isUnlockedByDefault: 0, sortOrder: 15, isActive: 1 },
    // Planta (planta_001 a planta_005)
    { id: "planta_001", element: "plant", tier: 1, name: "Floraspirit Primordial", assetPath: "assets/SkinsElementales/planta_001.png", priceCrystals: 0, priceOrbs: 0, isUnlockedByDefault: 1, sortOrder: 16, isActive: 1 },
    { id: "planta_002", element: "plant", tier: 2, name: "Floraspirit Brote", assetPath: "assets/SkinsElementales/planta_002.png", priceCrystals: 1500, priceOrbs: 15, isUnlockedByDefault: 0, sortOrder: 17, isActive: 1 },
    { id: "planta_003", element: "plant", tier: 3, name: "Floraspirit Silvestre", assetPath: "assets/SkinsElementales/planta_003.png", priceCrystals: 4000, priceOrbs: 40, isUnlockedByDefault: 0, sortOrder: 18, isActive: 1 },
    { id: "planta_004", element: "plant", tier: 4, name: "Floraspirit Selva", assetPath: "assets/SkinsElementales/planta_004.png", priceCrystals: 7500, priceOrbs: 70, isUnlockedByDefault: 0, sortOrder: 19, isActive: 1 },
    { id: "planta_005", element: "plant", tier: 5, name: "Floraspirit Primigenio", assetPath: "assets/SkinsElementales/planta_005.png", priceCrystals: 12000, priceOrbs: 120, isUnlockedByDefault: 0, sortOrder: 20, isActive: 1 },
    // Tierra (tierra_001 a tierra_005)
    { id: "tierra_001", element: "earth", tier: 1, name: "Terraspirit Primordial", assetPath: "assets/SkinsElementales/tierra_001.png", priceCrystals: 0, priceOrbs: 0, isUnlockedByDefault: 1, sortOrder: 21, isActive: 1 },
    { id: "tierra_002", element: "earth", tier: 2, name: "Terraspirit Rocoso", assetPath: "assets/SkinsElementales/tierra_002.png", priceCrystals: 1500, priceOrbs: 15, isUnlockedByDefault: 0, sortOrder: 22, isActive: 1 },
    { id: "tierra_003", element: "earth", tier: 3, name: "Terraspirit Fósil", assetPath: "assets/SkinsElementales/tierra_003.png", priceCrystals: 4000, priceOrbs: 40, isUnlockedByDefault: 0, sortOrder: 23, isActive: 1 },
    { id: "tierra_004", element: "earth", tier: 4, name: "Terraspirit Basalto", assetPath: "assets/SkinsElementales/tierra_004.png", priceCrystals: 7500, priceOrbs: 70, isUnlockedByDefault: 0, sortOrder: 24, isActive: 1 },
    { id: "tierra_005", element: "earth", tier: 5, name: "Terraspirit Titán", assetPath: "assets/SkinsElementales/tierra_005.png", priceCrystals: 12000, priceOrbs: 120, isUnlockedByDefault: 0, sortOrder: 25, isActive: 1 },
];

/** Caché de definiciones de catálogo en memoria */
let elementSkinsCatalogCache: ElementSkinDef[] = [...FALLBACK_ELEMENT_SKINS];

/** Mapas de caché para acelerar renderizado en PixiJS y Canvas2D */
const skinTextureCache = new Map<string, Texture>();
const skinImageCache = new Map<string, HTMLImageElement>();

/**
 * Mapea el elemento al ID de skin base por defecto:
 * 'water' | 'agua' ➔ 'agua_001'
 * 'fire' | 'fuego' ➔ 'fuego_001'
 * 'plant' | 'planta' ➔ 'planta_001'
 * 'electric' | 'electrico' | 'electricidad' ➔ 'electrico_001'
 * 'earth' | 'tierra' ➔ 'tierra_001'
 */
export function getDefaultSkinForElement(element: string | undefined): string {
    const el = (element || "water").toLowerCase().trim();
    switch (el) {
        case "water":
        case "agua":
            return "agua_001";
        case "fire":
        case "fuego":
            return "fuego_001";
        case "plant":
        case "planta":
            return "planta_001";
        case "electric":
        case "electrico":
        case "electricidad":
            return "electrico_001";
        case "earth":
        case "tierra":
            return "tierra_001";
        default:
            return "agua_001";
    }
}

/**
 * Retorna o crea el HTMLImageElement para la skin elemental.
 */
export function getElementSkinImage(skinId: string): HTMLImageElement {
    const cleanId = skinId || "agua_001";
    let img = skinImageCache.get(cleanId);
    if (!img) {
        const newImg = new Image();
        newImg.src = `assets/SkinsElementales/${cleanId}.png`;
        skinImageCache.set(cleanId, newImg);
        if (newImg.complete && newImg.naturalWidth > 0) {
            try {
                skinTextureCache.set(cleanId, Texture.from(newImg));
            } catch {}
        } else {
            newImg.addEventListener("load", () => {
                try {
                    if (newImg.naturalWidth > 0) {
                        skinTextureCache.set(cleanId, Texture.from(newImg));
                    }
                } catch {}
            }, { once: true });
        }
        return newImg;
    }
    return img;
}

/**
 * Retorna la textura PixiJS validada. Si la imagen aún se está descargando,
 * suscribe un listener de carga única y retorna null temporalmente.
 */
export function getElementSkinTexture(skinId: string): Texture | null {
    const cleanId = skinId || "agua_001";
    let tex = skinTextureCache.get(cleanId);
    if (tex) return tex;

    const img = getElementSkinImage(cleanId);
    if (img.complete && img.naturalWidth > 0) {
        try {
            tex = Texture.from(img);
            skinTextureCache.set(cleanId, tex);
            return tex;
        } catch (err) {
            console.warn("[ElementSkins] Error al crear textura desde imagen:", err);
            return null;
        }
    }

    // Suscribir carga si aún no ha terminado de descargar
    img.addEventListener("load", () => {
        try {
            if (img.naturalWidth > 0) {
                const loadedTex = Texture.from(img);
                skinTextureCache.set(cleanId, loadedTex);
            }
        } catch {}
    }, { once: true });

    return null;
}

/**
 * Consulta la API autoritativa de skins elementales para sincronizar catálogo.
 */
export async function syncElementSkinsFromServer(): Promise<ElementSkinDef[]> {
    try {
        const res = await fetch("/api/shop/element-skins");
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (data && Array.isArray(data.catalog) && data.catalog.length > 0) {
            elementSkinsCatalogCache = data.catalog;
            data.catalog.forEach((skin: ElementSkinDef) => {
                const img = getElementSkinImage(skin.id);
                if (img.complete && img.naturalWidth > 0) {
                    try {
                        skinTextureCache.set(skin.id, Texture.from(img));
                    } catch {}
                }
            });
        }
    } catch (err) {
        // En caso de fallo de red, conservamos el fallback estático
    }
    return elementSkinsCatalogCache;
}

/**
 * Retorna el catálogo actual en memoria.
 */
export function getElementSkinsCatalog(): ElementSkinDef[] {
    return elementSkinsCatalogCache;
}

// Inicialización automática y precarga total en entorno cliente
if (typeof window !== "undefined") {
    void syncElementSkinsFromServer();
    FALLBACK_ELEMENT_SKINS.forEach((skin) => {
        const img = getElementSkinImage(skin.id);
        if (img.complete && img.naturalWidth > 0) {
            try {
                skinTextureCache.set(skin.id, Texture.from(img));
            } catch {}
        } else {
            img.addEventListener("load", () => {
                try {
                    if (img.naturalWidth > 0) {
                        skinTextureCache.set(skin.id, Texture.from(img));
                    }
                } catch {}
            }, { once: true });
        }
    });
}
